import { Button, Container, Grid, GridColumn, Notice, Separator, Spinner, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import qs from 'qs';
import React from 'react';
import { ACCOUNT } from '../Routes';
import AccountPageHeader from '../account/AccountPageHeader';
import useStores from '../stores/UseStores';
import RemovalConfirmationModal from '../account/RemovalConfirmationModal';
import AccountLoginMethods from '../account/AccountLoginMethods';

export interface AccountReturnParams {
  app: string;
  locale: string;
  goto: string;
}

const AccountPage = observer((): React.JSX.Element => {
  const {
    languageStore: { currentLanguage },
    accountInfoStore,
    emailLoginStore,
    translateStore: { translate },
    routeStore,
  } = useStores();
  const { isLoading, isSessionValid } = accountInfoStore;

  React.useEffect(() => {
    emailLoginStore.verifyEmail(window.location.reload);
    accountInfoStore.loadInitialInfo();
  }, []);

  const loginNotice = (): React.JSX.Element | null => {
    if (isLoading || isSessionValid) {
      return null;
    }
    return (
      <Notice align="center">
        <Grid align={['between-xs', 'middle-xs']} noWrap={['sm']}>
          <GridColumn width={['xs', 'max-sm']}>
            <p>{translate('accountPage.loginNotice.text')}</p>
          </GridColumn>
          <GridColumn width={['xs', 'min-sm']}>
            <Button
              text={translate('accountPage.loginNotice.button')}
              url={`/${qs.stringify(getReturnParams(), { addQueryPrefix: true })}`}
              onClick={routeStore.navigate}
              variant="secondary"
              iconRight="#arrow-right"
            />
          </GridColumn>
        </Grid>
      </Notice>
    );
  };

  const getReturnParams = (): AccountReturnParams => {
    return {
      app: routeStore.decodedParams.app,
      locale: routeStore.decodedParams.locale || currentLanguage,
      goto: ACCOUNT,
    };
  };

  if (isLoading) {
    return <Spinner />;
  }
  const returnParams = getReturnParams();

  return (
    <Container>
      <Text>
        {loginNotice()}
        {isSessionValid && (
          <>
            <AccountPageHeader returnParams={returnParams} />
            <Separator color="invisible" spacing="xsmall" />
            <AccountLoginMethods returnParams={returnParams} />
            <RemovalConfirmationModal />
          </>
        )}
      </Text>
    </Container>
  );
});

export default AccountPage;
